import { render, staticRenderFns } from "./InitialCambiarPassword.vue?vue&type=template&id=391bb740&"
import script from "./InitialCambiarPassword.vue?vue&type=script&lang=js&"
export * from "./InitialCambiarPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports